export const estimateDocumentFieldNames = {
  companyName: "companyName",
  companyAddress: "companyAddress",
  companyContact: "companyContact",
  mainDescription: "mainDescription",
  estimateAddressTerms: "estimateAddressTerms",
  truckingTerms: "truckingTerms",
  paymentTerms: "paymentTerms",
  thanksNote: "thanksNote",
  estimateHeader: "estimateHeader",
};

export const estimateNotificationMessages = {
  saveSuccessMessage: "Estimate saved successfully!",
  saveFailureMessage: "Failed to save estimate!",
  emptyFieldMessage: "No field should be empty",
};

export const estimateHeader = {
  header: "Aggregate Supply Estimate",
  paymentHeader: "Payment Terms",
  thankyou: "Thank You",
  accountingDepartment: "Accounting Department",
  accountingDepartmentContent: "254.644.3714 | remittance@twistednail.com",
};

export const salesPersonFields = {
  salesPerson: "Salesperson",
  phone: "Phone",
  email: "Email",
};

export const getDefaultEstimateValues = (data?: DocumentType, id?: string) => {
  const templateEstimateValues = data?.data?.estimateContents?.find(
    (content) => content?.id === id
  );
  return {
    companyName: templateEstimateValues?.companyName,
    companyAddress: templateEstimateValues?.companyAddress,
    companyContact: templateEstimateValues?.companyContact,
    mainDescription: templateEstimateValues?.mainDescription,
    estimateAddressTerms: templateEstimateValues?.estimateAddressTerms,
    truckingTerms: templateEstimateValues?.truckingTerms,
    paymentTerms: templateEstimateValues?.paymentTerms,
    thanksNote: templateEstimateValues?.thanksNote,
    estimateHeader: templateEstimateValues?.estimateHeader,
  };
};
